import React from 'react';
import { FlexibleImageDisplay } from './flexible-image-display';
import { StandardCropData } from '@/modules/uiImages/types';
import { QrCodeIcon } from '@phosphor-icons/react';

interface ScanImageProps {
  imageUrl?: string;
  imageCroppedUrl?: string;
  crop?: StandardCropData;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  className?: string;
  showFallback?: boolean;
  fallbackIcon?: React.ReactNode;
  showCrop?: boolean;
}

export function ScanImage({
  imageUrl,
  imageCroppedUrl,
  crop,
  size = 'md',
  className = '',
  showFallback = true,
  fallbackIcon,
  showCrop = true
}: ScanImageProps) {
  const getFallbackIcon = () => {
    if (fallbackIcon) return fallbackIcon;
    return <QrCodeIcon className="h-6 w-6 text-lureo-ink-subtlest" />;
  };

  return (
    <FlexibleImageDisplay
      imageUrl={imageUrl}
      imageCroppedUrl={imageCroppedUrl}
      crop={crop}
      imageCategory="ScanImage"
      size={size}
      className={className}
      showCrop={showCrop}
      fallbackIcon={showFallback ? getFallbackIcon() : undefined}
    />
  );
}
